import React from "react";
import Header from "./Header";
import { Link } from "react-scroll";

const Bannersection = ({
  firstTitle,
  bannerHeading,
  bansubheading,
  scrolldown,
  bottomarrow,
  banpara,
}) => {






  return (
    <>
      <div className="container inner-container">
        <div className="bannersection">
          <Header />
          <div className="container inner-container">
            <div className="row">
              <div className="offset-lg-4 col-lg-8 offset-md-2 col-md-10 col-12 bannerContent">
                <p className="gateway">
                  <span></span> {firstTitle}
                </p>
                <h1
                  className="bannerheading"
                  dangerouslySetInnerHTML={{ __html: bannerHeading }}
                ></h1>
                {bansubheading && <p className="bansubheading"> {bansubheading} </p>}
                {scrolldown && (
                  <Link to="test1" smooth={true} offset={-20} spy={true} duration={500} className="bottomarrow">

                    {scrolldown}
                    <img
                      src={bottomarrow}
                      alt="bottom_arrow"
                      title="bottom arrow"
                    />
                  </Link>
                )}
              </div>
            </div>
            {banpara && (<div className="row">
              <div className="offset-lg-2 col-lg-10">
                <div className="banerParaWrapper">
                  <p className="banpara"> {banpara} </p>
                </div>
              </div>
            </div>)}
          </div>
        </div>
      </div>
    </>
  );
};

export default Bannersection;
